import { render, staticRenderFns } from "./ChatGPTEditor.vue?vue&type=template&id=1407de5b&"
import script from "./ChatGPTEditor.vue?vue&type=script&lang=js&"
export * from "./ChatGPTEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports